/**
 * A versão desta instalação, discreta no rodapé das telas.
 *
 * Existe para a pergunta que chega ao suporte por telefone — "qual versão
 * está aí?" — que num PWA ninguém consegue responder olhando: não há tela de
 * informações do sistema, e o service worker pode estar servindo uma versão
 * guardada de dias atrás. Em mono porque é um código para ler letra a letra.
 */

import React from 'react';
import {Text} from 'react-native';

import {VERSAO_NA_TELA} from '../web/versao';
import {txt, useIdioma} from './idioma';
import {fontes, useTema} from './tema';

export function Versao() {
  const t = useTema();
  useIdioma();

  return (
    <Text
      accessibilityLabel={txt('Versão do aplicativo {numero}', {numero: VERSAO_NA_TELA})}
      style={{
        color: t.textoApagado,
        fontSize: 11,
        fontFamily: fontes.mono,
        textAlign: 'center',
        letterSpacing: 0.2,
      }}>
      {VERSAO_NA_TELA}
    </Text>
  );
}
